module.exports = __webpack_public_path__ + "6dd4ff9bb225da2be7c63e25bcc1495c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-s.png
// module id = 3083
// module chunks = 0